"use strict";
/*
 * Created on 14. 5. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ObjectUtils_1 = require("../../core/utils/ObjectUtils");
/**
 * Composite productId-priceZoneId key. You can use it for both internal and external product
 * ids according to context of usage.
 * @author Radek Beran
 */


var ProductPriceZoneKey =
/*#__PURE__*/
function () {
  function ProductPriceZoneKey(productId, priceZoneId) {
    _classCallCheck(this, ProductPriceZoneKey);

    this.productId = productId;
    this.priceZoneId = priceZoneId;
  }

  _createClass(ProductPriceZoneKey, [{
    key: "equals",
    value: function equals(other) {
      if (other instanceof ProductPriceZoneKey) {
        var otherKey = other;
        return this.productId === otherKey.productId && this.priceZoneId === otherKey.priceZoneId;
      } else {
        return false;
      }
    }
  }, {
    key: "hashCode",
    value: function hashCode() {
      return ObjectUtils_1.ObjectUtils.hashCode(this.productId + '-' + this.priceZoneId);
    }
  }]);

  return ProductPriceZoneKey;
}();

exports.ProductPriceZoneKey = ProductPriceZoneKey;